// extracted by mini-css-extract-plugin
module.exports = {"loadMoreWrapper":"event-list_loadMoreWrapper__wvV_p"};